import { render, staticRenderFns } from "./SuggestInput.vue?vue&type=template&id=1a411540"
import script from "./SuggestInput.vue?vue&type=script&lang=js"
export * from "./SuggestInput.vue?vue&type=script&lang=js"
import style0 from "./SuggestInput.vue?vue&type=style&index=0&id=1a411540&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports